import { createFileRoute } from '@tanstack/react-router'

import { CatalogUnitOfMeasure } from '@/api/admin-products-types'
import { RouteModal } from '@/components/route-modal'
import { CatalogUnitForm } from '@/routes/_authenticated/settings/units-of-measure/-catalog-form'

export const Route = createFileRoute('/_authenticated/settings/units-of-measure/$unitUuid')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.UnitsOfMeasure.EditTitle()
	}
})

function RouteComponent() {
	const { unitUuid } = Route.useParams()

	return (
		<RouteModal prev='..' asDrawer requiresData loader={async api => await api.listUnitsOfMeasure({})}>
			{(units: CatalogUnitOfMeasure[]) => {
				const unit = units.find(candidate => candidate.uuid === unitUuid)
				if (!unit) {
					return null
				}
				return <CatalogUnitForm unit={unit} />
			}}
		</RouteModal>
	)
}
